// API Configuration

// Get the base URL from environment variables with fallback to production URL
export const BASE_URL = process.env.REACT_APP_API_BASE_URL || 'https://errands.fdebackend.com';

// Authentication Configuration
export const AUTH_CONFIG = {
  tokenKey: 'token',
  apiKeyHeader: 'Authorization',
};

// Default Values
export const DEFAULT_TEMPERATURE = 0.2;

// Pagination Configuration
export const PAGINATION = {
  pageSize: 10,
}; 